<template>
  <div id="app" class="jdy-page">
    <router-view />
    <svg-icon style='display:none'></svg-icon>
  </div>
</template>
<script>
  import svgIcon from '@/components/svg-icon'
  export default {
    name: 'App',
    components: { svgIcon }
  }
</script>




// WEBPACK FOOTER //
// src/App.vue